<template>
  <el-popover
    placement="right"
    title=""
    trigger="click">
    <img slot="reference" :src="imgSrc" class="">
    <img :src="imgSrc" class=""/>
  </el-popover>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    props: {
      imgSrc: {},
      defaultWidth: {
        default: 250
      },
      defaultHeight: {
        default: 150
      },
      afterWidth: {
        default: 500
      },
      afterHeight: {
        default: 300
      }
    },
    data () {
      return {}
    },
    computed: {
      ...mapState({})
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PopoverImg.vue?d582f7f0